import WRAP from "WRAP-JS";

/* eslint-disable */
// 元のコンストラクタを保存
const OriginalImageRenderer = WRAP.Renderer.Image;

// 新しいコンストラクタで置き換え
WRAP.Renderer.Image = function() {
  // 元のコンストラクタを呼ぶ
  OriginalImageRenderer.call(this);

  // Tileのコンストラクタにmag_filterを渡せるようにするため上書き
  this.draw = function(layer, content, conf, context, style, data, revision, dl) {

    if ( !content )
      content = {};

    var drawn_num = dl.length;

    var valid = true;
    if ( this.context_revision != revision.context ) {
      valid = false;
    }

    if ( this.content_revision != revision.content ) {
      valid = false;
    }

    if ( this.conf_revision != revision.conf ) {
      valid = false;
      drawn_num = 0;
      this.palette = null;
    }

    if ( this.style_revision != revision.style ) {
      valid = false;
      drawn_num = 0;
      this.palette = null;
    }

    if ( valid )
      return;

    var dh = data;
    var data_conf = dh.configuration('data');
    if ( data_conf.url ) {
      for ( var key in content) {
        if ( content[key] === null ) {
          if ( data_conf.url.indexOf('%'+key+'%') >=0 )
            return;
        }
      }
      if ( data_conf.url.indexOf('%validtime%') >=0 && !content.validtime )
        return;
    }

    var grid = data_conf && data_conf.Grid;
    if ( grid && grid.MinZoom > context.zoom ) {
      layer.clear();
      return;
    }

    var s = conf.Attributes.style.default;
    if ( style && conf.Attributes.style[style] )
      s = conf.Attributes.style[style];
    if ( !s ) {
      layer.setStatus({status:"error", reason:"style definition error."});
      return;
    }

    var sampling = null;

    var tiles = [];
    var drawn = [];
    for ( var i = 0 ; i < context.tiles.length ; i++ ) {
      var tile = context.tiles[i];
      for ( var j = 0 ; j < drawn_num ; j++ ) {
        var f = dl[j];
        if ( f.data && f.data.tile && f.data.tile.id == tile.id && f.data.revision == revision.content
          && f.data.projection == context.projection ) {
          drawn.push(f);
          tile = null;
          break;
        }
      }
      if ( tile )
        tiles.push(tile);
    }
    if ( tiles.length ) {
      layer.setStatus({status:"invalid", reason:"data load waiting."});

      var data_tile = this.getTileImage(data, 'data', tiles, content, sampling, layer);
      if ( !data_tile )
        return;

      //console.log("tiles="+tiles.length+" drawn="+drawn.length);

      layer.clear();

      for ( var i = 0 ; i < drawn.length ; i++ ) {
        layer.addFeature(drawn[i]);
      }

      for ( var i = 0 ; i < data_tile.length ; i++ ) {
        var src = data_tile[i];
        if ( !src || src.empty || !src.imageData ) {
          continue;
        }

        var tile = tiles[i];
        var pix = tile.ctx.createImageData(256,256);
        var sd = src.imageData.data;
        var dd = pix.data;
        if ( s.type == 'rgb_palette' && s.palette ) {
          WRAP.Util.Assembly.mapTileRGB(dd, sd, s.palette);
        }
        else if ( s.type == 'grayscale_palette' && s.palette ) {
          WRAP.Util.Assembly.mapTileGrayscale(dd, sd, s.palette);
        }
        else if ( s.type == 'filter') {
          var rgb_offset = parseInt(s.rgb_offset) || 0;
          var opacity = parseFloat(s.opacity) || 1.0;
          WRAP.Util.Assembly.mapTileFilter(dd, sd, rgb_offset, opacity);
        }
        else {
          dd.set(sd);
        }
        var feature = new WRAP.Geo.Feature.Tile({
          tile:tile,
          imageData:pix,
          min_filter:s.min_filter,
          mag_filter:s.mag_filter
        });
        feature.data = { tile:tile, revision:revision.content, projection:context.projection };
        layer.addFeature(feature);
      }

      //WRAP.Geo._tileCheck(context, layer);
    }

    this.context_revision = revision.context;
    this.content_revision = revision.content;
    this.conf_revision = revision.conf;
    this.style_revision = revision.style;
    this.last_zoom = context.zoom;
    if ( !tiles.length || layer.getStatus().status != 'error' )
      layer.setStatus({status:"valid"});
    WRAP.Geo.invalidate();
  }
};
/* eslint-enable */
